import React from "react";

/**
 * Renders the Advantage Warranty Group horizontal logo.
 * Sizes are keyed to logo height (in px) since it's a wide lockup (~4.2:1).
 */
export function BrandLogo({ size = "md", variant = "dark", className = "" }) {
  const heights = { sm: 32, md: 44, lg: 64, xl: 96 };
  const h = heights[size] || heights.md;
  // On dark backgrounds we invert with a subtle brightness lift; but since
  // the source logo already has its own color set, we let it render natively.
  const style = { height: h, width: "auto" };
  // The lockup is full-colour (blue/silver) and reads well on both light and
  // dark backgrounds, so no recolouring — just a soft glow on dark surfaces.
  const darkStyle =
    variant === "light"
      ? { ...style, filter: "drop-shadow(0 0 6px rgba(255,255,255,0.25))" }
      : style;
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <img
        src="/brand/awg-logo.png"
        alt="Advantage Warranty Group"
        style={darkStyle}
        draggable={false}
      />
    </div>
  );
}
